module.exports = __webpack_public_path__ + "assets/65a5f9f82d04e276736551a190fb5d7e.png";